import { Pipe, PipeTransform } from '@angular/core';
import { LocationsService } from '../../services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CountriesMap } from '../../dto';

@Pipe({
    name: 'companyLocationCountryNameByAbbreviation',
    standalone: false
})
export class CompanyLocationCountryNameByAbbreviationPipe implements PipeTransform {
	constructor(
		private readonly locationsService: LocationsService,
	) {
	}

	transform(abbr: string): Observable<string> {
        return this.locationsService.locationsMap$.pipe(map((locationsMap: CountriesMap) => (locationsMap?.[abbr]?.name || '')));
	}
}
